import React, { useMemo, useState } from "react";
import { RootState } from "../../support/store";
import { useSelector } from "react-redux";
import Highlighter from "react-highlight-words";
import { HbrIcon, HbrInput } from "@harbor/elements-react-standalone";
import { magnifyingGlass } from "@harbor/elements/icons";
import { Link } from "react-router-dom";
import NavHistoryTracker from "../../navigation/NavHistoryTracker";
import { asSingleValue } from '../../support/utils';


const ArchitectureList = () => {
  const architectures = useSelector((state: RootState) => state.gtmSolutions.architectures);
  const [search, setSearch] = useState('');

  const handleSearchChange = (value: string) => {
    setSearch(value.toLowerCase());
  };

  const filteredArchitectures = useMemo(() => {
    if (!search) return architectures ?? [];
    return (architectures ?? [])
      .filter(
        (architecture) =>
          (architecture?.name ?? '').indexOf(search) > -1 ||
          (architecture?.description ?? '').indexOf(search) > -1
      );
  }, [search, architectures]);

  return (
    <section className='mx-4 mb-6'>
      <NavHistoryTracker title="All Architectures" />
      <header className='mb-4 mt-6'>
        <div className='flex'>
          <HbrInput
            placeholder='Search architectures'
            value={search}
            size='large'
            clearable={true}
            onHbr-change={(e) => handleSearchChange(asSingleValue(e.target.value))}
            className=''
          >
            <HbrIcon
              slot='prefix'
              name='magnifying-glass'
              asset={magnifyingGlass}
              size='16px'
              staticColors={true}
            />
          </HbrInput>
        </div>
      </header>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4'>
        {filteredArchitectures.map((architecture) => (
          <Link to={`/solutions/architecture/${architecture.id}`} key={architecture.id} className=''>
            <div
              key={architecture.id}
              className='cursor-pointer p-4 rounded-xl border border-gray-20 h-full flex flex-col items-center text-center bg-gray-10 transition-colors duration-500 hover:bg-gray-15 hover:border-gray-30'
            >
              <h4 className='my-1 leading-5'>
                <Highlighter
                  highlightClassName='font-semibold p-px -m-px rounded-sm bg-warning-lighter'
                  searchWords={[search]}
                  autoEscape={true}
                  textToHighlight={architecture?.name ?? ''}
                />
              </h4>
              <p className='text-sm leading-4 my-1'>
                <Highlighter
                  highlightClassName='font-semibold p-px -m-px rounded-sm bg-warning-lighter'
                  searchWords={[search]}
                  autoEscape={true}
                  textToHighlight={architecture?.description ?? ''}
                />
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ArchitectureList;